module.exports = __webpack_public_path__ + "static/ol-54ec70474ab14c52e59c3d6fd8685aa8.jpg";